import MicIcon from '@mui/icons-material/Mic';
import MicOffIcon from '@mui/icons-material/MicOff';
import { IconButton, Theme, Tooltip } from '@mui/material';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { muteCall } from '../../../store/dialer';
import { useAppDispatch } from '../../../store/hooks';

export default function ActiveCallMuteIcon() {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();

    const [isMute, setIsMute] = React.useState<boolean>(false);

    const handleMute = () => {
        dispatch(muteCall(!isMute));
        setIsMute(!isMute);
    };

    React.useEffect(() => {
        return () => {
            setIsMute(false);
        };
    }, []);

    return (
        <Tooltip title={isMute ? 'Unmute' : 'Mute'}>
            <IconButton size="large" onClick={handleMute}>
                {isMute ? <MicOffIcon /> : <MicIcon />}
            </IconButton>
        </Tooltip>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    root: {},
}));
